import { initRefreshManager } from '@rayvision/refresh-manager'
import { createDeployRefreshQuery } from '@/api/deploy-refresh'
import {
  DEFAULT_INTERVAL_CONFIG_KEY,
  DEFAULT_INTERVAL_CONFIG_REFRESH_INTERVAL,
  DEFAULT_STORAGE_KEY_PREFIX,
} from './constants'

let manager = null
let initialized = false
let started = false

export function ensureRefreshManagerInitialized() {
  if (initialized && manager) return manager

  manager = initRefreshManager({
    intervalConfigKey: DEFAULT_INTERVAL_CONFIG_KEY,
    intervalConfigRefreshInterval: DEFAULT_INTERVAL_CONFIG_REFRESH_INTERVAL,
    storageKeyPrefix: DEFAULT_STORAGE_KEY_PREFIX,
    query: createDeployRefreshQuery(),
    onError(error) {
      console.error('[refresh-manager] refresh failed', error)
    },
  })
  initialized = true

  return manager
}

export function ensureRefreshManagerStarted() {
  const currentManager = ensureRefreshManagerInitialized()

  if (!started) {
    currentManager.start()
    started = true
  }

  return currentManager
}
